import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, onWheel, ...props }, ref) => {
  // Prevent mouse wheel from changing numeric input values
  // This avoids accidental value changes when scrolling while focused on a number field
  const handleWheel = React.useCallback((e) => {
    if (type === "number") {
      // Blur the input to prevent value change, then restore focus state
      // This allows normal page/modal scrolling to continue
      e.currentTarget.blur();
      // Re-focus after a microtask to maintain user's position in the form
      // but only if the user didn't click elsewhere
      const target = e.currentTarget;
      setTimeout(() => {
        if (document.activeElement === document.body) {
          target.focus({ preventScroll: true });
        }
      }, 0);
    }
    // Call any existing onWheel handler
    onWheel?.(e);
  }, [type, onWheel]);

  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      onWheel={handleWheel}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
